import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const InputTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          marginBottom: 14,
        },
      },
    },
  },
});

export const SearchBarTheme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          height: "57px",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          backgroundColor: "rgb(244, 246, 248)",
          overflow: "hidden",
          position: "relative",
          borderRadius: "16px",
          padding: "5px",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          width: "100%",
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
        },
        input: {
          marginLeft: "20px",
        },
      },
    },
  },
});

export const ButtonSendTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#0a9c75",
          fontSize: 16,
          "&:hover": {
            backgroundColor: "#0a9c75",
          },
        },
      },
    },
  },
});

export const DropDownTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          marginBottom: 0,
        },
      },
    },
  },
});

export const TableListTheme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          width: "100%",
          border: 0,
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        root: {
          width: "100%",
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
        },
        input: {
          marginLeft: "20px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          height: "60px",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          backgroundColor: "rgb(244, 246, 248)",
          overflow: "hidden",
          position: "relative",
          borderRadius: "16px",
          padding: "24px",
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          maxHeight: "100vh",
        },
      },
    },
  },
});

export const stockTableListTheme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          height: "60px",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          backgroundColor: "rgb(244, 246, 248)",
          overflow: "hidden",
          position: "relative",
          borderRadius: "8px",
          padding: "24px",
        },
      },
    },
  },
});

export const transferInvoiceDialog = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          border: 1,
          borderRadius: 2,
          overflow: "hidden",
          borderColor: "red",
        },
      },
    },
  },
});

export const CommissionManageTheme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          minWidth: "100%",
          minHeight: "60vh",
          [theme.breakpoints.down("xl")]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        }),
      },
    },
  },
});

export const productDiscountTheme = createTheme({
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          maxHeight: "79vh",
          border: "1px solid black",
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: "auto",
          borderCollapse: "separate",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          minWidth: 130,
          height: 60,
          whiteSpace: "pre-wrap",
          paddingLeft: 10,
          paddingBottom: 0,
          paddingTop: 0,
          paddingRight: 10,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": { backgroundColor: "white" },
        },
      },
    },
  },
});
export const NotPageTheme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          height: "100vh",
          backgroundColor: grey[100],
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "black",
          textAlign: "center",
        },
      },
    },
  },
});

export const productDiscounTableRowTheme = createTheme({
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1,
        },
      },
    },
  },
});
export const NotPageThemeText = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 100,
          fontWeight: 400,
          color: "green",
          textAlign: "center",
        },
      },
    },
  },
});

export const employeeShoppingTheme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          position: "fixed",
          left: "50%",
          transform: "translate(-50%)",
          zIndex: 1,
        },
      },
    },
  },
});

export const employeeShoppingTabTheme = createTheme({
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          "& .MuiTab-root.Mui-selected": {
            color: "#0A9C75",
            fontSize: 15,
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#0A9C75",
          },
        },
      },
    },
  },
});

export const questionnarieReportComparisonTheme = createTheme({
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          wordBreak: "break-all",
          whiteSpaceCollapse: "break-spaces",
        },
      },
    },
  },
});

export const questionnarieReportTheme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          wordBreak: "break-all",
          whiteSpaceCollapse: "break-spaces",
        },
      },
    },
  },
});

export const itItemListTheme = createTheme({
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: 150,
        },
      },
    },
  },
});
